"use strict";
//@ts-nocheck
// window.albyEvent causing issues in lib-ts, after fixing the server folder to ts and having only lib this will be solved
Object.defineProperty(exports, "__esModule", { value: true });
exports.albyEventViewedVariant = exports.albyEventViewedCollection = exports.albyEventViewedCart = exports.albyEventSearch = exports.albyEventRemovedFromCart = exports.albyEventPurchase = exports.albyEventViewedProduct = exports.albyEventAddedToCart = exports.albyPurchasePixel = exports.setAlbyConfiguration = exports.ALBY_BRAND_ID = void 0;
const helpers_1 = require("components/FormatPrice/helpers");
exports.ALBY_BRAND_ID = '474bd7da-ae8b-481b-891a-23c539975072';
// https://help.alby.com/help/ab-testing-alby
const setAlbyConfiguration = ({ isAlbyABTest }) => {
    if (typeof window !== 'undefined') {
        window.albyConfig = window.albyConfig || {};
        window.albyConfig.test_id = 'Test1';
        window.albyConfig.test_version = isAlbyABTest ? 'alby' : 'control';
        window.albyConfig.test_description = 'Testing new user engagement feature';
    }
};
exports.setAlbyConfiguration = setAlbyConfiguration;
// function from Alby docs https://developers.alby.com/docs/purchase-confirmation-pixel
const albyPurchasePixel = ({ cart, orderId, orderTotal, isAlbyABTest, }) => {
    const cartItems = Array.isArray(cart === null || cart === void 0 ? void 0 : cart.items) ? cart.items : [];
    const _ALBY_ORDER_INFO = {
        brand_id: exports.ALBY_BRAND_ID,
        order_id: orderId,
        order_total: orderTotal,
        variant_ids: cartItems.map(({ sku }) => sku),
        currency: 'USD',
        test_id: 'Test1',
        test_version: isAlbyABTest ? 'alby' : 'control',
        test_description: 'Testing new user engagement feature',
    };
    let url = 'https://tr.alby.com/p?' +
        (function (i) {
            if (i instanceof Object) {
                const s = [];
                for (const o in i)
                    if (i[o]) {
                        const r = i[o], e = encodeURIComponent(o) + '=' + encodeURIComponent(r);
                        s.push(e);
                    }
                return s.join('&');
            }
            return '';
        })(_ALBY_ORDER_INFO), cookies = document.cookie.split(';'), sessionCookie = cookies.filter(function (i) {
        return i.trim().startsWith('_alby_session=');
    })[0], userCookie = cookies.filter(function (i) {
        return i.trim().startsWith('_alby_user=');
    })[0];
    sessionCookie && (url += '&session=' + sessionCookie.split('=')[1]),
        userCookie && (url += '&user_id=' + userCookie.split('=')[1]),
        fetch(url);
};
exports.albyPurchasePixel = albyPurchasePixel;
// Behavioral Events docs: https://developers.alby.com/docs/behavioral-events
const albyEventAddedToCart = ({ productPriceInDollars, quantity = 1, artworkId, sku, }) => {
    window.albyEvent = window.albyEvent || [];
    window.albyEvent.push('AddedToCart', {
        variantId: sku,
        cost: { amount: productPriceInDollars, currencyCode: 'USD' },
        quantity: quantity,
        productId: artworkId,
    });
};
exports.albyEventAddedToCart = albyEventAddedToCart;
const albyEventViewedProduct = ({ artworkId, sku }) => {
    window.albyEvent = window.albyEvent || [];
    window.albyEvent.push('ViewedProduct', {
        productId: artworkId,
        variantId: sku,
    });
};
exports.albyEventViewedProduct = albyEventViewedProduct;
const albyEventPurchase = ({ cart, orderId }) => {
    const cartItems = Array.isArray(cart === null || cart === void 0 ? void 0 : cart.items) ? cart.items : [];
    window.albyEvent = window.albyEvent || [];
    window.albyEvent.push('Purchase', {
        orderId: orderId, // required
        total: {
            amount: (0, helpers_1.convertFromCentsToDollarsString)((cart === null || cart === void 0 ? void 0 : cart.totalOrderPriceToPay) || 0),
            currencyCode: 'USD',
        },
        items: cartItems.map(({ artworkId, sku, quantity, price }) => ({
            productId: artworkId,
            variantId: sku,
            quantity: quantity,
            cost: {
                amount: (0, helpers_1.convertFromCentsToDollarsString)((price === null || price === void 0 ? void 0 : price.totalPriceToPay) || 0), //Product price to pay after discounts, with taxes. in US dollars, not cents
                currencyCode: 'USD',
            },
        })),
    });
};
exports.albyEventPurchase = albyEventPurchase;
const albyEventRemovedFromCart = ({ sku, productPriceInDollars, artworkId, }) => {
    window.albyEvent = window.albyEvent || [];
    window.albyEvent.push('RemovedFromCart', {
        variantId: sku,
        cost: { amount: productPriceInDollars, currencyCode: 'USD' },
        quantity: 1,
        productId: artworkId,
    });
};
exports.albyEventRemovedFromCart = albyEventRemovedFromCart;
const albyEventSearch = ({ querySearch, results }) => {
    window.albyEvent = window.albyEvent || [];
    window.albyEvent.push('Search', {
        query: querySearch,
        results: results.map(({ artworkId, sku }) => ({
            productId: artworkId,
            variantId: sku,
        })),
    });
};
exports.albyEventSearch = albyEventSearch;
const albyEventViewedCart = ({ cart }) => {
    const cartItems = Array.isArray(cart === null || cart === void 0 ? void 0 : cart.items) ? cart.items : [];
    window.albyEvent = window.albyEvent || [];
    window.albyEvent.push('ViewedCart', {
        cost: {
            amount: (0, helpers_1.convertFromCentsToDollarsString)((cart === null || cart === void 0 ? void 0 : cart.totalOrderPriceToPay) || 0),
            currencyCode: 'USD',
        },
        items: cartItems.map(({ artworkId, sku, quantity, price }) => ({
            productId: artworkId,
            variantId: sku,
            quantity: quantity,
            cost: {
                amount: (0, helpers_1.convertFromCentsToDollarsString)((price === null || price === void 0 ? void 0 : price.totalPriceToPay) || 0), //Product price to pay after discounts, with taxes. in US dollars, not cents
                currencyCode: 'USD',
            },
        })),
    });
};
exports.albyEventViewedCart = albyEventViewedCart;
const albyEventViewedCollection = ({ collectionDetails, }) => {
    window.albyEvent = window.albyEvent || [];
    window.albyEvent.push('ViewedCollection', {
        title: '',
        items: [
            {
                productId: 'summer1',
                variantId: 'var1',
            },
            {
                productId: 'summer2',
                variantId: 'var2',
            },
            {
                productId: 'summer3',
                variantId: 'var3',
            },
        ],
        collectionId: '',
    });
};
exports.albyEventViewedCollection = albyEventViewedCollection;
const albyEventViewedVariant = ({ sku }) => {
    var _a;
    window.albyEvent = window.albyEvent || [];
    (_a = window === null || window === void 0 ? void 0 : window.albyEvent) === null || _a === void 0 ? void 0 : _a.push('ViewedVariant', {
        variantId: sku,
    });
};
exports.albyEventViewedVariant = albyEventViewedVariant;
